<!-- PWAPrompt.vue -->
<template>
  <div v-if="shown" class="pwa-prompt" id="promoPWa">
    Add CarbonXo to Home screen?

    <button @click="installPWA" class="install-button">Install!</button>

    <button @click="dismissPrompt" class="close-button" id="closePromoButton">
      No, thanks
    </button>
  </div>
</template>

<script>
export default {
  data: () => ({
    shown: false,
  }),

  beforeMount() {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.installEvent = e;
      this.shown = true;
    });
  },

  methods: {
    dismissPrompt() {
      this.shown = false;
    },

    installPWA() {
      this.installEvent.prompt();
      this.installEvent.userChoice.then((choice) => {
        this.dismissPrompt(); // Hide the prompt once the user's clicked
        if (choice.outcome === "accepted") {
          // Do something additional if the user chose to install
        } else {
          // Do something additional if the user declined
        }
      });
    },
  },
};
</script>

<style scoped>
.pwa-prompt {
  position: fixed;
  font-size: 1.25rem;
  z-index: 20;
  line-height: 1;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;
  background: #013301;
  color: white;
  transform: translateY(0);
  margin: 0;
}

.install-button {
  font-size: inherit;
  margin: 0 0 0 0.5rem;
  padding: 0.25em 0.5em;
  background-color: #ffffff;
  color: #013301;
  border: 0;
  border-radius: 4px;
  line-height: 1;
  text-transform: uppercase;
  font-weight: 600;
}
.close-button {
  font-size: inherit;
  margin: 0 0 0 0.5rem;
  padding: 0.25em 0.5em;
  background-color: #ffffff;
  color: #013301;
  border: 0;
  border-radius: 4px;
  line-height: 1;
  text-transform: uppercase;
  font-weight: 600;
}
</style>
